export default __webpack_public_path__ + "static/media/new_dg_logo.63c9ec2d.png";